import { Col, Row, Select, message } from 'antd';
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, InputNumber } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { addUser, fetchOneUser, updateUser } from 'redux/features/user';
import { fetchAllWajib } from 'redux/features/wajib_pajak';
import { getUserProfile } from "redux/features/auth";
import { kabupatens } from "constants/DataConstant"

export const TAMBAH_BA = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation()

  const [kabupaten, setKabupaten] = useState("");
  const [idPMO, setIdPMO] = useState("");

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values)
    } else {
      createData(values)
    }
  }

  const createData = async (values) => {
    try {
      const response = await dispatch(getUserProfile()).unwrap();
      await dispatch(addUser({
        ...values,
        role_id: 3,
        kabupaten: kabupaten,
        id_pmo: response.data.user.username,
        password: '1234567890'
      })).unwrap()
      history.push("/app/my-ba")
    } catch (error) {
      message.error(error?.message || 'Failed to register')
    }
  }

  const updateData = async (values) => {
    try {
      await dispatch(updateUser({ ...values, role_id: 3, kabupaten: kabupaten, id: location?.state?.id })).unwrap()
      history.push("/app/my-ba")
    } catch (error) {
      message.error(error?.message || 'Failed to fetch data')
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneUser(id)).unwrap()
      form.setFieldsValue({
        ...data.data
      });
    } catch (err) {
      console.log(err)
    }
  }

  const getUserData = async () => {
    try {
      const response = await dispatch(getUserProfile()).unwrap();
      setKabupaten(response.data.user.kabupaten);
      setIdPMO(response.data.user.username);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserData()
    if (location?.state?.id) {
      getDataById(location?.state?.id)
    }
  }, [])

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Data Business Assistant {kabupaten}</h2>
          <p>Tolong isikan data sesuai dengan data pengguna</p>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >

              <Form.Item
                label="Nama PMO"
                name="id_pmo"
              >
                <>{idPMO}</>
              </Form.Item>
              <Form.Item
                label="Nama Lengkap"
                name="username"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="No HP"
                name="no_phone"
              >
                <Input />
              </Form.Item>
              

              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default TAMBAH_BA